import { OriginationChannel } from './origination-channel.enum';

export class ReferralInfoModel {
  referralCompany?: string;
  referralContactName?: string;
  referralContactNumber?: string;
  referralEmailAddress?: string;
  referralType?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  referralCityId?: number = 0;
  referralStateId?: number = 0;
  referralStreetId?: number = 0;
  referralZipId?: number = 0;
  referralCompanyId?: number = 0;
  referralContactNameId?: number = 0;
  referralContactNumberId?: number = 0;
  referralEmailId?: number = 0;
  referralTypeId?: number = 0;
}
export class HouseholdMemberModel {
  age?: number = null;
  disabled?: boolean = false;
  fullTimeStudent?: boolean = false;
  houseHoldMemberName?: string = '';
  receivesIncome?: boolean = false;
  sourceIncome?: string = '';
  houseHoldMemberNameId?: number = null;
  ageId?: number = null;
  fullTimeStudentId?: number = null;
  disabledId?: number = null;
  receivesIncomeId?: number = null;
  sourceIncomeId?: number = null;
  isDeleted?: boolean = false;
}

export class LoanInfoCombinedHousingExpenseModel {
  firstMortgageProposed?: number;
  grossTotalIncome?: number;
  hazardInsuranceProposed?: number;
  hoADuesPaymentProposed?: number;
  mortgageInsuranceProposed?: number;
  otherProposed?: number;
  otherFiPaymentProposed?: number;
  proposedTotal?: number;
  realEstateTaxProposed?: number;
}

export interface RelatedLoanModel {
  affordableLoan?: boolean;
  creditorName?: string;
  fundsSourceType?: number;
  helocCreditLimit?: number;
  isConcurrentlyClosing?: boolean; //isConcurrent?: boolean;
  isHeloc?: boolean;
  lienPriorityType?: LienPriorityType; //lienType?: string;
  balanceAtClosing?: number; //loanAmount?: number;
  monthlyPayment?: number;
  relatedLoanId?: number;
}

export enum LienPriorityType {
  notAssigned = 0,
  first = 1,
  second = 2,
  third = 3,
  forth = 4,
}

export class LoanPropertyFeeWorksheetModel {
  afterImprovedValue?: string;
  amortizationTypeDescOV?: string;
  applicationDeposit?: number;
  appraisalProductName?: string;
  appraisedValue?: number;
  apr?: number;
  baseLoan?: number;
  borrowerCityName?: string;
  borrowerFullName?: string;
  borrowerPostalCode?: string;
  borrowerStateName?: string;
  borrowerStreet?: string;
  caseNoAssignmentPeriod?: number;
  cemaLoan?: boolean;
  cltv?: number;
  currentLender?: string;
  currentUnpaidPrincipleBalanceamount?: number;
  daysOfPerDiem?: number;
  discount?: number;
  downPaymentAmount?: number;
  downPaymentPercentage?: number;
  dpfactor?: string;
  earnestMoneyDeposit?: number;
  estClosingDateStringFormat?: string;
  everHadVALoan?: number;
  existingSecondLien?: number;
  fileCreditScore?: number;
  finalOrReinspection1004dRequired?: boolean;
  fundingFeeType?: number;
  inProcessingDate?: string;
  interestOnlyPeriod?: string;
  intRate?: number;
  isJumbo?: boolean;
  isLoanANewConstruction?: boolean;
  isPropertyTBD?: boolean;
  jumboRequiredSecondAppraisal?: boolean;
  lienPosition?: string;
  loanEstimatedClosingDate?: string;
  loanProductType?: number;
  loanProgramCode?: string;
  loanProgramName?: string;
  loanPurpose?: number;
  loanPurposeOther?: string;
  loanWith?: number;
  lockCanceledDate?: string;
  lockExpirationDate?: string;
  lockFloating?: boolean;
  lockStartDate?: string;
  loCommunicationToDisclosuresAmcValue?: number;
  ltv?: number;
  miPaidInCash?: number;
  miPFFFinancingCalcOption?: number;
  monthlyMIAmount?: number;
  monthlyMIFactor?: string;
  monthOrYearCurrentLoanWasTaken?: string;
  mortgageType?: number;
  mortgageTypeOther?: string;
  noOfUnits?: number;
  occupancy?: number;
  propertyoriginalPrincipalofCurrentLoan?: number;
  pmiType?: number;
  property?: number;
  refiPurpAU?: number;
  refiTypeFHA?: number;
  refiTypeVA?: number;
  rushAppraisal?: boolean;
  salesPrice?: number;
  sectionOfAct?: number;
  sizeInAcres?: number;
  specialFloodHazardArea?: boolean;
  subordinateAmount?: number;
  subPropCityName?: string;
  subPropCounty?: string;
  subPropCountyFips?: string;
  subPropPostalCode?: string;
  subPropStateFips?: string;
  subPropStateName?: string;
  subPropStreet?: string;
  term?: number;
  townShip?: string;
  upfrontMiAmount?: number;
  upfrontMIFactor?: string;
  upfrontMiType?: string;
  veteranHasDisability?: number;
  waiveEscrow?: number;
  yearCurrentPropertyWasPurchased?: string;
}

export class LoanDataModel {
  address?: string;
  afterImprovedValue?: string;
  agencyCaseNumber?: string;
  amortizationType?: number;
  amortizationTypeDescription?: string;
  appraisalValue?: number;
  areYouDisabledVeteran?: boolean;
  armIntRateAdjustAt?: number;
  armIntRateFixedFor?: number;
  baseLoanAmount?: number;
  buyDowns?: number;
  caseNumberAssignedDate?: number;
  channel?: number;
  cltv?: number;
  creditScoreMedian?: number;
  downPaymentAmount?: number;
  downPaymentPercentage?: number;
  doYouOwnMoreThan4Dwelling?: number;
  dpfactor?: string;
  dwellingCoveredDetails?: string;
  loanPropertyFeeWorksheet?: LoanPropertyFeeWorksheetModel;
  fhaCity?: string;
  fhaState?: string;
  fhaStreet?: string;
  fhaZip?: string;
  fhaCashOutRefiAcquiredDate?: Date;
  fhaOccupancySeasoningDate?: Date;
  dateOwnedAndOccupied?: Date;
  vaSixMonthlyPaymentDate?: Date;
  fileDataId?: number;
  fileName?: string;
  fundingFeeType?: number;
  gusFirstRunDate?: number;
  hasPrepaymentPenalty?: boolean;
  haveYouSoldRealEstateIn60Months?: boolean;
  homeOwnedThroughVa?: number;
  householdMembers?: HouseholdMemberModel[];
  inProcessingDate?: string;
  interestOnlyPeriod?: number;
  interestRate?: number;
  isBalloon?: boolean;
  isDwellingToBeCovered?: number;
  isInterestOnly?: boolean;
  isItToBeSold?: number;
  isJumbo?: boolean;
  isNegativeAmortization?: boolean;
  isOther?: boolean;
  isPrepaymentPenalty?: boolean;
  isTemporaryBuydown?: boolean;
  lenderCaseNumber?: string;
  lenderFhaId?: string;
  lenderVaId?: string;
  loanId?: number;
  loanInfoCombinedHousingExpense?: LoanInfoCombinedHousingExpenseModel;
  loanProgramCode?: string;
  loanProgramName?: string;
  loanPurpose?: number;
  loanTerm?: number;
  lockExpirationDate?: string;
  lockStartDate?: string;
  ltv?: number;
  miPaidInCash?: number;
  mipffFinancingCalcOption?: number;
  monthlyMCC?: number;
  monthlyMiAmount?: number;
  monthlyMiFactor?: number;
  mortgageAppliedFor?: MortgageType;
  organizationId?: number;
  originalMortgageAmount?: number;
  originationChannel?: OriginationChannel;
  otherMortgageDescription?: string;
  otherPurposeDescription?: string;
  pmiType?: number;
  prepaymentPenaltyTerm?: number;
  productDescription?: number;
  productDescriptionOther?: string;
  qualRate?: number;
  referralInfo?: ReferralInfoModel;
  refinancePurposeAu?: number;
  refinancePurposeFha?: number;
  refinancePurposeVa?: number;
  relatedLoans?: RelatedLoanModel[];
  salesPrice?: number;
  sectionOfAct?: number;
  soldSalesPriceFha?: number;
  sponsorFhaid?: string;
  sponsorVaid?: string;
  subOrdinateFinance?: SubordinateFinanceModel;
  totalLoanAmount?: number;
  totalMOnthlyPayments?: number;
  upfrontMiAmount?: number;
  upfrontMiFactor?: number;
  upfrontMiType?: string;
  userId?: number;
  //  Added
  readonly upfrontMiAmountId?: number;
  readonly downPaymentAmountId?: number;
  readonly downPaymentPercentageId?: number;
  readonly dpFactorId?: number;
  readonly upfrontMiTypeId?: number;
  readonly fHA203KId?: number;
  readonly fHAMCAWId?: number;
  readonly primaryApplicationId?: number;
  readonly primaryBorrowerId?: number;
}

export class LoanFeaturesModel {
  isBalloon: boolean;
  isInterestOnly: boolean;
  isNegativeAmortization: boolean;
  isPrepaymentPenalty: boolean;
  hasPrepaymentPenalty: boolean;
  prepaymentPenaltyTerm: number;
  isTemporaryBuydown: boolean;
  isOther: boolean;
  productDescription: number;
  productDescriptionOther: string;
}

export class SubordinateFinanceModel {
  calculatedPi: number;
  dotId: number;
  excludeSubFi: boolean;
  hcltv: number;
  helocMaxBalance: number;
  subFiBaseLoan: number;
  subFiIntOnly: boolean;
  subFiIntRate: number;
  subFiTerm: number;
  subFiType: SubFiType; // enum SubFiTypes;
}

export class LoanInfoRequest {
  loanPurpose = '';
  mortgageType = 0;
  fundingFeeType = 0;
  downPayment = 0;
  salesPrice = 0;
  baseLoan = 0;
  upfrontMiType = '';
  upfrontMiAmount = 0;
  downPaymentPercent = 0;
  dpFactor = '';
  principleAndInterest = 0;
  proposedCombinedHousingExpenses = 0;
  grossMonthlyIncome = 0;
  totalMonthlyPayment = 0;
  monthlyMCC = 0;
  appraisalValue = 0;
  subordinateFinanceAmount = 0;
  hellocCreditLimit = 0;
  loanTerm = 0;
  interestRate = 0;
  fhaCaseNoAssigned: number = null;
  monthlyMiFactor = 0;
  upfrontMiFactor = 0;
  occupancyType = 0;
  PresentCombinedHousingExpenses = 0;
}

export class LoanInfoResponse {
  baseLoan = 0;
  upfrontMiFactor = 0;
  upfrontMiAmount = 0;
  mipPaidInCash = 0;
  noteLoanAmount = 0;
  firstRatio = 0;
  secondRatio = 0;
  ltv = 0;
  cltv = 0;
  hcltv = 0;
  firstMortgagePI = 0;
  monthlyMiAmount = 0;
  monthlyMiFactor = 0;
  piti = 0;
}

export class LtvCltvHcltvResponse {
  ltv = 0;
  cltv = 0;
  hcltv = 0;
}

export interface RHSFactorMatrix {
  usdaCaseNoAssigned: number;
  mipFactor: number;
  upfrontMiFactor: number;
  isRefinance: boolean;
}

export interface FHAFactorMatrix {
  fhaCaseNoAssigned: number;
  mipFactor: number;
  ltvGreaterThanLimit: boolean;
}

export interface RHSFactorMatrix {
  usdaCaseNoAssigned: number;
  mipFactor: number;
  upfrontMiFactor: number;
  isRefinance: boolean;
}

export interface loanInfoResponse {
  baseLoan: number;
  upfrontMiFactor: number;
  upfrontMiAmount: number;
  mipPaidInCash: number;
  noteLoanAmount: number;
  firstRatio: number;
  secondRatio: number;
  ltv: number;
  cltv: number;
  hcltv: number;
  firstMortgagePI: number;
  monthlyMiFactor: number;
  monthlyMiAmount: number;
  piti: number;
}

export enum LoanPurposeType {
  notAssigned = 0,
  purchase = 1,
  refinance = 2,
  construction = 3,
  constructionPerm = 4,
  second = 5,
  third = 6,
  purchaseMoneySecond = 7,
  other = 8,
  purchaseMoneyThird = 9,
}

export enum RefiTypeVA {
  notAssigned = 0,
  IRRR = 1,
  other = 2,
}

export enum MortgageType {
  notAssigned = 0,
  va = 1,
  fha = 2,
  conventional = 3,
  usda = 4,
  other = 5,
  heloc = 6,
  stateAgency = 7,
  localAgency = 8,
}
export enum UpfrontMiType {
  select = '',
  paidInCash = 'paidInCash',
  financed = 'financed',
}
export enum PurposeOfLoan {
  select = 0,
  purchase = 1,
  refinance = 2,
  construction = 3,
  constructionPerm = 4,
  second = 5,
  third = 6,
  purchaseMoneySecond = 7,
  other = 8,
  purchaseMoneyThird = 9,
}

export enum PmiType {
  select = null,
  none = 1,
  monthly = 0,
  standard = 3,
  singlePremRefund = 4,
  singlePremNonRefund = 5,
  lenderPaid = 7,
  splitPremNonRefund = 8,
}

export enum SectionOfAct {
  select = 0,
  _203b = 1,
  _203_b_2 = 2,
  _203_b_251 = 3,
  _203_k = 4,
  _221_d_2 = 5,
  _221_d_2_251 = 6,
  _234_c = 7,
  _234_c_251 = 8,
  _184 = 9,
}

export enum FundingFeeType {
  select = 0,
  regularMilitaryFirstUse = 1,
  regularMilitarySusequentUse = 2,
  reservesOrGuardFirstUse = 3,
  reservesOrGuardSubsequentUse = 4,
  interestRateReductionRefi = 5,
  manufacturedHome = 6,
  loanAssumption = 7,
  exempt = 8,
}

export enum DpFactorType {
  select = 'Select, Enter Base Loan',
  downpaymentPercentage = 'Downpayment Percentage (%)',
  downpaymentAmount = 'Downpayment Amount ($)',
}

export enum StoreProperty {
  qualRate = 0,
  monthlyMiAmount = 1,
  upfrontMiAmount = 2,
  upfrontMiFactor = 3,
  totalLoanAmount = 4,
  monthlyMiFactor = 5,
  loanProgramName = 6,
  amortizationType = 7,
  interestOnlyPeriod = 8,
  isJumbo = 9,
  fundingFeeType = 10,
  loanTerm = 11,
  loanProgramCode = 12,
  caseNumberAssignedDate = 13,
  gusFirstRunDate = 14,
  pmiType = 15,
  upfrontMiType = 16,
  miPaidInCash = 17,
  interestRate = 18,
  baseLoanAmount = 19,
  amortizationTypeDescription = 20,
  loanPurpose = 21,
}

export enum SubFiType {
  notAssigned = 0,
  notHeloc = 1,
  heloc = 3,
}
